import {} from '@mui/material';
import { hexToHSL } from 'utils/functions';

const getOppositeHue = hue => {
  const newHue = hue + 180;
  if (newHue <= 360) return newHue;
  return newHue - 360;
};

const getNewGoldenHue = hue => {
  const goldenHueStep = 137.508;
  const newHue = hue + goldenHueStep;
  if (newHue <= 360) return newHue;
  return newHue - 360;
};

const saturateColor = hsl => {
  const saturation = Number(hsl.substring(hsl.indexOf(',') + 1, hsl.indexOf('%')));
  if (saturation < 20) return hsl.replace(`${saturation}%`, `${saturation + 80}%`);
  return hsl;
};

const lightenColor = hsl => {
  const lightness = Number(hsl.substring(hsl.indexOf('%') + 2, hsl.lastIndexOf('%')));
  if (lightness < 40) return hsl.substring(0, hsl.indexOf('%') + 2) + 40 + hsl.substring(hsl.lastIndexOf('%'));
  return hsl;
};

export const getChartColors = (startingColor, count) => {
  let currentColorHsl = hexToHSL(startingColor);

  const colors = [currentColorHsl];

  if (count == 0) {
    return colors;
  }

  currentColorHsl = saturateColor(currentColorHsl);
  currentColorHsl = lightenColor(currentColorHsl);

  let isOpposite = true;

  [...Array(count - 1)].forEach(_ => {
    if (isOpposite) {
      const hue = Number(currentColorHsl.substring(4, currentColorHsl.indexOf(',')));
      const newHue = getOppositeHue(hue);
      currentColorHsl = currentColorHsl.replace(String(hue), newHue);
      colors.push(currentColorHsl);
      isOpposite = false;
    } else {
      const hue = Number(currentColorHsl.substring(4, currentColorHsl.indexOf(',')));
      const newHue = getNewGoldenHue(hue);
      currentColorHsl = currentColorHsl.replace(String(hue), newHue);
      colors.push(currentColorHsl);
      isOpposite = true;
    }
  });

  return colors;
};
